module.exports = __webpack_public_path__ + "img/swipe1-icon-active.e05a4a91.png";